import { Search } from '@mui/icons-material';
import { Box, ButtonBase } from '@mui/material';
import React from 'react';
import { searchElementSx } from './searchElementSx';
import { useSharedTFunction } from '@shared/i18n';

interface Props {
  onClick: () => void;
}

export const SearchButton = ({ onClick }: Props) => {
  const t = useSharedTFunction();

  return (
    <ButtonBase onClick={onClick} sx={searchElementSx}>
      <Search />
      <Box component="span" ml={2}>
        {t('shared.helpCenter.search')}
      </Box>
    </ButtonBase>
  );
};
